import React, { useEffect } from 'react'

import { Box, Flex, Text, Button, TableContainer, Table, Thead, Tbody, Th, Td, Stack, Tr, Heading} from '@chakra-ui/react'

import { GrFormAdd } from 'react-icons/gr'

import { Link } from 'react-router-dom'
import { axiosInstance } from '../lib/api'

import { addExpense, addBudget } from '../features/expenseSlice/expenseSlice'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

export function ListedItems() { 
  const dispatch = useDispatch()
  const list = useSelector(state => state.expense.list)
  const budget = useSelector((state) => state.expense.budget)
  useEffect(() => {
        axiosInstance.get('expense/')
        .then((response) => {
          console.log(response);
          dispatch(addExpense(response.data))
        }, [dispatch])
        .catch(function (error) {
          console.log(error);
        })

        axiosInstance.get('budget/')
        .then((response) => {
          console.log(response);
          dispatch(addBudget(response.data))
        })
        .catch(function (error) {
          console.log(error);
        })
  }, [dispatch])
  return(
    <Box mx={10} mt={10}>
      <Flex justifyContent={{base: 'center', md: 'space-around', lg: 'space-around'}} direction={{base: 'column', md: 'row', lg: 'row'}} fontSize={{base: '14px', md: '18px', lg: '21px'}}>
      <Stack spacing={1}>
        <TableContainer>
        <Heading mb={5} size={'md'}>Expense</Heading>
          <Table variant={'simple'}>
          <Thead>
            <Tr>
            <Th>Item</Th>
            <Th>Price</Th>
            </Tr>
          </Thead>

          <Tbody>
          {list && list.map(data => (
            <Tr key={data.id}>
            <Td>{data.item}</Td>
            <Td>{data.price}</Td>
            <Td colSpan={3}>
              <Button colorScheme={'pink'}>
                Delete
              </Button>
            </Td>
            </Tr>
              ))}
          </Tbody>
          </Table>
        </TableContainer>
      </Stack>

      <Stack spacing={1} mt={10}>
        <TableContainer>
        <Heading mb={5} size={'md'}>Budget</Heading>
          <Table variant={'simple'}>
          <Thead>
            <Tr>
            <Th>Name</Th>
            <Th>Amount</Th>
            </Tr>
          </Thead>

          <Tbody>
          {budget.length === 0 ? 
          <Flex direction={'column'} alignItems={'center'}>
          <Text textAlign={'center'} mt={4} fontWeight={600}>No budget for now</Text> 
          <Link to='/budget'>
          <Button mt={5} type={'button'} leftIcon={<GrFormAdd />} colorScheme="pink" variant="outline">
          Budget
        </Button>
          </Link>
        </Flex>
        :
          budget.map(data => (
            <Tr key={data.id}>
            <Td>{data.name}</Td>
            <Td>{data.amount}</Td>
            <Td colSpan={3}>
              <Button colorScheme={'pink'} fontSize={{base: '10px'}}>
                Delete
              </Button>
            </Td>
            </Tr>
              ))}

          </Tbody>
          </Table>
        </TableContainer>
      </Stack>
      </Flex>
    </Box>
  )
}

export default function ExpenseList() {
  const navigate = useNavigate()
  const list = useSelector((state) => state.expense.list) 
  const budget = useSelector((state) => state.expense.budget)
  const totalExpenseAmount = list.reduce((acc, obj) => { return acc + Math.round(obj.price); }, 0);
  const totalBudgetAmount = budget.reduce((acc, obj) => { return acc + Math.round(obj.amount); }, 0);
    const checkNegativeBalance = (e) => {
      e.preventDefault();
      totalBudgetAmount < totalExpenseAmount ?
      Swal.fire({
        title: 'Budget exhausted!',
        text: 'Sorry, your budget is exhausted. \n Try to update your budget or add new budget.',
        imageUrl: 'https://media.istockphoto.com/photos/paying-bills-picture-id1342044426?k=20&m=1342044426&s=612x612&w=0&h=OEycNuomrepjCZXQzA2xyg2XhnEnQRdptaCYt-eXNNY=',
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: 'Custom image',
      })
        :
        navigate('/expense')

    };
  return (
    <Box>
      <Flex alignItems={'center'} justifyContent={'space-around'} direction={'row'} my={5} mx={5}>
        <Box>
        <Text fontWeight={500} mb={5}>Total: {totalExpenseAmount}</Text>
        <Link to='/expense'>
            <Button type={'button'} leftIcon={<GrFormAdd />} colorScheme="pink" variant="outline" onClick={checkNegativeBalance}>
              Expense
        </Button>
        </Link>
        </Box>

        <Box>
        <Text fontWeight={500} mb={5}>Total: {totalBudgetAmount}</Text>
        <Link to='/budget'>
            <Button type={'button'} leftIcon={<GrFormAdd />} colorScheme="pink" variant="outline">
              Budget
        </Button>
        </Link>
        </Box>
      </Flex>
        <ListedItems />
    </Box>
  )
}

